import { PaymentMethod, PaymentType } from './typing';

export function valueOfMethod(method: PaymentMethod): [PaymentType, string] {
  const [type, mode] = method.split(':');
  return [type as PaymentType, mode as string];
}

export function isAlipayPaymentType(method: PaymentMethod): boolean {
  const [type] = valueOfMethod(method);
  return type === 'ALIPAY';
}

export function isWechatpayPaymentType(method: PaymentMethod): boolean {
  const [type] = valueOfMethod(method);
  return type === 'WECHATPAY';
}
